enum RoleConfig {
  SchoolManager = 666,
  SchoolAdmin = 777,
  SupportPerson = 555,
}

export default RoleConfig;
